import { Control, Path, useWatch } from 'react-hook-form';
import { ExtendedTarificationFormData } from '@/types/benefits/tarification/TarificationFormData';
import PricingSummaryCalendar from './PricingSummaryCalendar';

interface BenefitPricingSummaryProps<
  FieldsType extends ExtendedTarificationFormData,
> {
  control: Control<FieldsType>;
}

const BenefitPricingSummary = <
  FieldsType extends ExtendedTarificationFormData,
>({
  control,
}: BenefitPricingSummaryProps<FieldsType>) => {
  const currentTarifs = useWatch({
    control,
    name: 'tarifs' as Path<FieldsType>,
  }) as ExtendedTarificationFormData['tarifs'];

  return <PricingSummaryCalendar tarifs={currentTarifs} />;
};

export default BenefitPricingSummary;
